import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Las apps nativas linkean /mobile/keys/creation directo (Android desde dos
// lugares, siempre con lock_id). Redirigir en vez de mantener dos pantallas
// hace que obtengan el rediseño sin pasar por las stores. La query se pasa
// entera: perder el lock_id dejaría a la persona eligiendo puerta de nuevo.
export const KeysCreationRedirect: React.FC = () => {
    const { search } = useLocation();
    return <Navigate to={`/mobile/give-access/key${search}`} replace />;
};
